export default __webpack_public_path__ + "85a5a590615674d3f0919347d0b56a55.png";